import { render, staticRenderFns } from "./SetupWizardStep1.vue?vue&type=template&id=3edd1a66&scoped=true&"
import script from "./SetupWizardStep1.vue?vue&type=script&lang=js&"
export * from "./SetupWizardStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd1a66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
